module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.showMenu) ? _c('li', {
    staticClass: "nav-item btn-group"
  }, [_c('a', {
    staticClass: "nav-link dropdown-toggle",
    attrs: {
      "id": "dropdownMenu2",
      "data-toggle": "dropdown",
      "aria-haspopup": "true",
      "aria-expanded": "false"
    }
  }, [_c('i', {
    staticClass: "fa fa-user-circle-o"
  }), _vm._v(_vm._s(_vm.$store.state.userDeprecated.data.username))]), _vm._v(" "), _c('div', {
    staticClass: "dropdown-menu",
    attrs: {
      "aria-labelledby": "dropdownMenu2"
    }
  }, [(_vm.dashboardURL) ? _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": _vm.dashboardURL
    }
  }, [_vm._v("dashboard")]) : _vm._e(), _vm._v(" "), _c('router-link', {
    staticClass: "dropdown-item",
    attrs: {
      "to": _vm.settingsURL
    }
  }, [_vm._v(_vm._s(_vm.t('settings')))]), _vm._v(" "), _c('Logout')], 1)]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0487df2b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0487df2b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Navigation/UserMenu.vue
// module id = 754
// module chunks = 3